import loadable from '@loadable/component';

export const SearchRefinementsSwitchLoadable = loadable(
  () => import('./SearchRefinementsSwitch'),
  { resolveComponent: (module) => module.SearchRefinementsSwitch },
);
